// 管理员登录状态（zustand）
import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { AdminSummary } from "@/types/common";

interface AuthState {
  accessToken: string | null;
  user: AdminSummary | null;
  setSession: (token: string, user: AdminSummary) => void;
  clear: () => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      user: null,
      setSession: (accessToken, user) => set({ accessToken, user }),
      clear: () =>
        set({
          accessToken: null,
          user: null,
        }),
    }),
    {
      name: "heartsound-admin-auth",
    },
  ),
);
